import {getPaymentOptions} from '../../../selectors/PaymentOptionSelectors/PaymentOptionSelectors';
import {getSelectedDeliveryCountry} from '../../../selectors/selectors';
import * as types from '../../action-types';

const initialiseBillingAddressByPayment = (paymentOptions, country) => ({
  type: types.INITIALISE_BILLING_ADDRESS,
  paymentOptions,
  country,
});

export default () => (dispatch, getState) => {
  const paymentOptions = getPaymentOptions(getState());
  if (paymentOptions?.length > 0) {
    const paymentOptionTypeList = paymentOptions.map(option => option?.type?.toLowerCase());
    const filteredPaymentOptionTypeList = paymentOptionTypeList.filter(type => type !== 'adyen_v2');
    dispatch(initialiseBillingAddressByPayment(filteredPaymentOptionTypeList, getSelectedDeliveryCountry(getState())));
  }
};
